// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const AlertMap = __t.object("AlertMap", {
  alertname: __t.string(),
  components: __t.array(__t.string()),
  get impact() {
    return Impact;
  },
  titleTemplate: __t.string(),
  enabled: __t.bool(),
});
export type AlertMap = __Infer<typeof AlertMap>;

export const Component = __t.object("Component", {
  key: __t.string(),
  env: __t.string(),
  group: __t.string(),
  name: __t.string(),
  description: __t.string(),
  sort: __t.u32(),
  probeUrl: __t.string(),
  get probeKind() {
    return ProbeKind;
  },
});
export type Component = __Infer<typeof Component>;

export const ComponentState = __t.object("ComponentState", {
  componentKey: __t.string(),
  get state() {
    return State;
  },
  since: __t.timestamp(),
  reason: __t.string(),
  get overrideState() {
    return __t.option(State);
  },
  overrideReason: __t.string(),
  lastProbeAt: __t.timestamp(),
  lastOkAt: __t.timestamp(),
  consecutiveFail: __t.u32(),
  consecutiveOk: __t.u32(),
  build: __t.string(),
});
export type ComponentState = __Infer<typeof ComponentState>;

// The tagged union or sum type for the algebraic type `GrantScope`.
export const GrantScope = __t.enum("GrantScope", {
  Deploy: __t.unit(),
  Alert: __t.unit(),
});
export type GrantScope = __Infer<typeof GrantScope>;

// The tagged union or sum type for the algebraic type `Impact`.
export const Impact = __t.enum("Impact", {
  None: __t.unit(),
  Minor: __t.unit(),
  Major: __t.unit(),
  Critical: __t.unit(),
});
export type Impact = __Infer<typeof Impact>;

export const Incident = __t.object("Incident", {
  id: __t.u64(),
  title: __t.string(),
  get impact() {
    return Impact;
  },
  get status() {
    return IncidentStatus;
  },
  components: __t.array(__t.string()),
  get source() {
    return Source;
  },
  openedAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  resolvedAt: __t.option(__t.timestamp()),
  auto: __t.bool(),
  alertGroupKey: __t.string(),
});
export type Incident = __Infer<typeof Incident>;

// The tagged union or sum type for the algebraic type `IncidentStatus`.
export const IncidentStatus = __t.enum("IncidentStatus", {
  Investigating: __t.unit(),
  Identified: __t.unit(),
  Monitoring: __t.unit(),
  Resolved: __t.unit(),
});
export type IncidentStatus = __Infer<typeof IncidentStatus>;

export const IncidentUpdate = __t.object("IncidentUpdate", {
  id: __t.u64(),
  incidentId: __t.u64(),
  at: __t.timestamp(),
  get status() {
    return IncidentStatus;
  },
  message: __t.string(),
  author: __t.string(),
});
export type IncidentUpdate = __Infer<typeof IncidentUpdate>;

export const Maintenance = __t.object("Maintenance", {
  id: __t.u64(),
  title: __t.string(),
  components: __t.array(__t.string()),
  startsAt: __t.timestamp(),
  endsAt: __t.timestamp(),
  get status() {
    return MaintenanceStatus;
  },
  message: __t.string(),
  get source() {
    return Source;
  },
  runId: __t.string(),
});
export type Maintenance = __Infer<typeof Maintenance>;

// The tagged union or sum type for the algebraic type `MaintenanceStatus`.
export const MaintenanceStatus = __t.enum("MaintenanceStatus", {
  Scheduled: __t.unit(),
  InProgress: __t.unit(),
  Completed: __t.unit(),
  Failed: __t.unit(),
});
export type MaintenanceStatus = __Infer<typeof MaintenanceStatus>;

export const Operator = __t.object("Operator", {
  identity: __t.identity(),
  label: __t.string(),
});
export type Operator = __Infer<typeof Operator>;

export const Overall = __t.object("Overall", {
  key: __t.string(),
  get state() {
    return State;
  },
  headline: __t.string(),
  updatedAt: __t.timestamp(),
});
export type Overall = __Infer<typeof Overall>;

// The tagged union or sum type for the algebraic type `ProbeKind`.
export const ProbeKind = __t.enum("ProbeKind", {
  Ping: __t.unit(),
  Route: __t.unit(),
  Health: __t.unit(),
  External: __t.unit(),
});
export type ProbeKind = __Infer<typeof ProbeKind>;

export const ProbeResult = __t.object("ProbeResult", {
  id: __t.u64(),
  componentKey: __t.string(),
  at: __t.timestamp(),
  ok: __t.bool(),
  httpCode: __t.u16(),
  latencyMs: __t.u32(),
  detail: __t.string(),
});
export type ProbeResult = __Infer<typeof ProbeResult>;

export const ProbeSchedule = __t.object("ProbeSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type ProbeSchedule = __Infer<typeof ProbeSchedule>;

export const ProbeTick = __t.object("ProbeTick", {
  id: __t.u8(),
  ticks: __t.u64(),
  lastRunAt: __t.timestamp(),
});
export type ProbeTick = __Infer<typeof ProbeTick>;

export const ServiceGrant = __t.object("ServiceGrant", {
  identity: __t.identity(),
  label: __t.string(),
  get scope() {
    return GrantScope;
  },
  env: __t.string(),
});
export type ServiceGrant = __Infer<typeof ServiceGrant>;

export const Setting = __t.object("Setting", {
  key: __t.string(),
  value: __t.string(),
});
export type Setting = __Infer<typeof Setting>;

// The tagged union or sum type for the algebraic type `Source`.
export const Source = __t.enum("Source", {
  Manual: __t.unit(),
  Deploy: __t.unit(),
  Alert: __t.unit(),
  Probe: __t.unit(),
});
export type Source = __Infer<typeof Source>;

// The tagged union or sum type for the algebraic type `State`.
export const State = __t.enum("State", {
  Operational: __t.unit(),
  Degraded: __t.unit(),
  MajorOutage: __t.unit(),
  Maintenance: __t.unit(),
  Unknown: __t.unit(),
});
export type State = __Infer<typeof State>;

export const UptimeDay = __t.object("UptimeDay", {
  id: __t.u64(),
  componentKey: __t.string(),
  day: __t.string(),
  okCount: __t.u32(),
  failCount: __t.u32(),
  get worstState() {
    return State;
  },
});
export type UptimeDay = __Infer<typeof UptimeDay>;

